import React from "react";
import * as PropTypes from "prop-types";
import nouislider from "nouislider";
import "nouislider/distribute/nouislider.css";

const NoUiSliderHook = (props) => {
    const { onChange } = props;

    const inputEl = React.useRef(null);
    const slider = React.useRef(undefined);

    React.useEffect(() => {
        const _slider = nouislider.create(inputEl.current, {
            range: props.range,
            start: props.value,
            margin: props.margin,
            connect: props.connect,
            pips: props.pips,
            step: props.step,
            tooltips: props.tooltips,
            format: props.format,
            behaviour: props.behaviour,
        });

        _slider.on("change", () => _onChange());

        slider.current = _slider;

        return () => {
            slider.current.destroy();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (slider && slider.current && props.value) {
            slider.current.set(props.value);
        }
    }, [props.value]);

    const _onChange = React.useCallback(() => {
        if (onChange) {
            const [lower, upper] = slider.current.get();

            onChange({
                lower,
                upper,
            });
        }
    }, [onChange, slider]);

    return <div ref={inputEl} />;
};

NoUiSliderHook.propTypes = {
    range: PropTypes.shape({
        min: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
        max: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
    }).isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
    step: PropTypes.number,
    margin: PropTypes.number,
    connect: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.bool)]),
    pips: PropTypes.oneOfType([
        PropTypes.shape({
            mode: PropTypes.oneOf(["count"]),
            values: PropTypes.number.isRequired,
            density: PropTypes.number.isRequired,
        }),
    ]),
    format: PropTypes.object,
    tooltips: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.object])),
    ]),
    behaviour: PropTypes.string,
    onChange: PropTypes.func,
};

export default NoUiSliderHook;
